import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { CardDeleteSuccessAction } from './card-delete-success-dialog.action';

/* @ngInject */
export default class CardDeleteSuccessDialogController
  implements ActionHandler {
  public currentItem: string;
  private dialogElement;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element
      .find('#card-delete-success-dialog')
      .remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof CardDeleteSuccessAction) {
      this.openDialog();
    }
  }

  public onClick() {
    this.dialogElement.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

   private close(){
    this.dialogElement.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/card-delete-success-dialog/card-delete-success-dialog.controller.ts